export class AppleApplicationLockChanged {
  constructor(udid: string, bundleIdentifier: string, locked: boolean) {
    this.udid = udid;
    this.bundleIdentifier = bundleIdentifier;
    this.locked = locked;
  }

  udid: string;
  bundleIdentifier: string;
  locked: boolean;
}
